import React, { useEffect, useMemo, useState } from "react";
import { ToastContainer } from "react-toastify";
import useDash from "../../assets/css/dash.module.css";
import { FontColor, FourGround } from "../../assets/js/theme";
import {
  ArchiveFill,
  ArrowClockwise,
  KeyFill,
  PenFill,
  PersonPlusFill,
  ThreeDots,
} from "react-bootstrap-icons";
import Table from "../../components/table/Table";
import Sidebar from "../../components/admin/sidebar/Sidebar";
import AdminDialog from "./AdminDialog";
import { deleteAdmin, getAdmins } from "../../features/apiCallAdmin";
import { useDispatch, useSelector } from "react-redux";
import { badge } from "../../components/common/Utils";
import PasswordReset from "../../components/modals/passwordReset/PasswordReset";

const Admins = () => {
  const dispatch = useDispatch();

  //---> Get admins from redux store
  const admins = useSelector((state) => state.admin?.admin);

  //---> Loading State
  const [loading, setLoading] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [modalStatus, setModalStatus] = useState("");
  const [show, setShow] = useState(false);
  const [admin, setAdmin] = useState(false);
  const [isUpdate, setIsUpdate] = useState(false);

  useEffect(() => {
    getAdmins(dispatch, setIsLoading);
  }, []);

  const columns = useMemo(
    () => [
      {
        width: "5%",
        Header: "#",
        id: "row",
        accessor: (row) => Number(row.id + 1),
        Cell: ({ row }) => <strong>{Number(row.id) + 1}</strong>,
      },
      {
        width: "12%",
        Header: "Name",
        accessor: "name",
      },
      {
        width: "12%",
        Header: "Mobile",
        accessor: "mobile",
      },
      {
        width: "8%",
        Header: "Status",
        accessor: "status",
        Cell: ({ cell: { value } }) => <p>{badge(value)}</p>,
      },
      {
        width: "7%",
        Header: () => <div className="text-center">Action</div>,
        id: "option",
        Cell: ({ row: { original } }) => (
          <div className="d-flex justify-content-center align-items-center">
            <div className="dropdown">
              <ThreeDots
                className="dropdown-toggle ActionDots"
                id="areaDropdown"
                type="button"
                data-bs-toggle="dropdown"
                aria-expanded="false"
              />
              <ul className="dropdown-menu" aria-labelledby="resellerDropdown">
                <li
                  onClick={() => {
                    setAdmin(original);
                    setModalStatus("admin");
                    setShow(true);
                    setIsUpdate(true);
                  }}
                >
                  <div className="dropdown-item">
                    <div className="customerAction">
                      <PenFill />
                      <p className="actionP">Edit</p>
                    </div>
                  </div>
                </li>

                <li
                  onClick={() => {
                    setAdmin(original);
                    setModalStatus("passwordReset");
                    setShow(true);
                  }}
                >
                  <div className="dropdown-item">
                    <div className="customerAction">
                      <KeyFill />
                      <p className="actionP">Reset Password</p>
                    </div>
                  </div>
                </li>

                <li onClick={() => handleDeleteAdmin(original?._id)}>
                  <div className="dropdown-item">
                    <div className="customerAction">
                      <ArchiveFill />
                      <p className="actionP">Delete</p>
                    </div>
                  </div>
                </li>
              </ul>
            </div>
          </div>
        ),
      },
    ],
    []
  );

  const handleDeleteAdmin = (adminId) => {
    const confirm = window.confirm(
      "Are you sure you want to delete this admin?"
    );
    if (confirm) {
      deleteAdmin(dispatch, adminId, setLoading);
    }
  };

  return (
    <>
      <Sidebar />
      <ToastContainer position="top-right" theme="colored" />

      <div className={useDash.dashboardWrapper}>
        <div className="container-fluied collector">
          <div className="container">
            <FontColor>
              <FourGround>
                <div className="collectorTitle d-flex justify-content-between px-4">
                  <div>Admin</div>
                  <div className="d-flex justify-content-center align-items-center">
                    {/* <div className="reloadBtn">
                      {isLoading ? (
                        <Loader />
                      ) : (
                        <ArrowClockwise
                          className="arrowClock"
                          title={t("refresh")}
                          onClick={() => reloadHandler()}
                        />
                      )}
                    </div> */}

                    <div
                      onClick={() => {
                        setModalStatus("admin");
                        setShow(true);
                      }}
                    >
                      <PersonPlusFill className="addcutmButton" />
                    </div>
                  </div>
                </div>
              </FourGround>

              <FourGround>
                <div className="collectorWrapper mt-2 py-1">
                  <div className="table-section">
                    <Table
                      isLoading={isLoading}
                      columns={columns}
                      data={admins}
                    />
                  </div>
                </div>
              </FourGround>
            </FontColor>
          </div>
        </div>
      </div>

      {modalStatus === "admin" && (
        <AdminDialog {...{ show, setShow, isUpdate, admin }} />
      )}

      {/* password reset modal */}
      {modalStatus === "passwordReset" && (
        <PasswordReset show={show} setShow={setShow} userId={admin?.user} />
      )}
    </>
  );
};

export default Admins;
